<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div id="time-set" class="Form--pt">
          <div class="Form__area Form__setting">
            <p class="Form__tx Form__tx--mb_md _ft-lft _ft-cl08">
              ※通知はアプリをインストールすると届きます。
            </p>
            <div class="Form__setting_box">
              <div class="Form__setting_head">
                クラス開始前通知
              </div>
              <p class="Form__label Form__label_setting">
                「通知する」に設定したクラスが開始する前に通知が届きます
              </p>
              <div :class="`Form__input_box_fx Form__input_box--mt_xs ${$v.userInfo.time_before_received_class_start_notification.$invalid ? '_error' : ''}`">
                <input
                  v-model="$v.userInfo.time_before_received_class_start_notification.$model"
                  class="Form__input Form__btn--pd_sp_sm Form__input_number Form__input--sm"
                  value="10"
                  type="tel"
                  pattern="\d*"
                  min="0"
                  max="1440"
                  @keypress="onlyNumber"
                >
                <div>分前に通知する</div>
                <div class="Form__error_box">
                  <div class="Form__error_tx">
                    0~1440分の間で設定してください
                  </div>
                </div>
              </div>
            </div>
            <div class="Form__setting_box">
              <div class="Form__setting_head">
                お気に入りのクラス前日通知
              </div>
              <p class="Form__label Form__label_setting">
                お気に入りに設定したクラスが翌日に開催される際に通知が届きます
              </p>
              <div class="Form__input_box--mt_sm">
                <div class="Radio__area">
                  <label class="Radio__box">
                    <input
                      v-model="$v.userInfo.is_received_favorite_class_notification.$model"
                      class="Radio__box_input"
                      type="radio"
                      name="radio1"
                      value="1"
                    >
                    <span class="Radio__box_input_dummy" />
                    <span class="Radio__box_tx">通知する</span>
                  </label>
                  <label class="Radio__box">
                    <input
                      id="check-fav"
                      v-model="$v.userInfo.is_received_favorite_class_notification.$model"
                      class="Radio__box_input"
                      type="radio"
                      name="radio1"
                      value="0"
                    >
                    <span class="Radio__box_input_dummy" />
                    <span class="Radio__box_tx">通知しない</span>
                  </label>
                </div>
              </div>
              <div id="timebox-fav" :class="`Form__input_time_box Form__input_box_fx Form__input_box--mt_sm ${$v.userInfo.favorite_class_notification_received_time.$invalid ? '_error' : ''}`">
                <div class="Form__input_time--mr Time__box Time__box_chrome">
                  <input
                    v-model="$v.userInfo.favorite_class_notification_received_time.$model"
                    class="Form__input Time__box_input"
                    type="time"
                  >
                  <div class="Form__error_box">
                    <div class="Form__error_tx">
                      <label v-if="!$v.userInfo.favorite_class_notification_received_time.required">時間を入力してください</label>
                    </div>
                  </div>
                </div>
                <div>に通知する</div>
              </div>
            </div>
            <div class="Form__setting_box">
              <div class="Form__setting_head">
                ログのリマインド
              </div>
              <p class="Form__label Form__label_setting">
                設定した時刻にログ入力のリマインド通知が届きます
              </p>
              <div class="Form__input_box--mt_sm">
                <div class="Radio__area">
                  <label class="Radio__box">
                    <input
                      v-model="$v.userInfo.is_received_log_input_notification.$model"
                      class="Radio__box_input"
                      type="radio"
                      name="radio2"
                      value="1"
                    >
                    <span class="Radio__box_input_dummy" />
                    <span class="Radio__box_tx">通知する</span>
                  </label>
                  <label class="Radio__box">
                    <input
                      v-model="$v.userInfo.is_received_log_input_notification.$model"
                      class="Radio__box_input"
                      type="radio"
                      name="radio2"
                      value="0"
                    >
                    <span class="Radio__box_input_dummy" />
                    <span class="Radio__box_tx">通知しない</span>
                  </label>
                </div>
              </div>
              <div id="timebox-log" :class="`Form__input_time_box Form__input_box_fx Form__input_box--mt_sm ${$v.userInfo.log_input_notification_received_time.$invalid ? '_error' : ''}`">
                <div class="Form__input_time--mr Time__box Time__box_chrome">
                  <input
                    v-model="$v.userInfo.log_input_notification_received_time.$model"
                    class="Form__input Time__box_input"
                    type="time"
                  >
                  <div class="Form__error_box">
                    <div class="Form__error_tx">
                      <label v-if="!$v.userInfo.log_input_notification_received_time.required">時間を入力してください</label>
                    </div>
                  </div>
                </div>
                <div>に通知する</div>
              </div>
            </div>
            <div class="Form__setting_box">
              <div class="Form__setting_head">
                INFORMATION
              </div>
              <p class="Form__label Form__label_setting">
                イベント開催などをお知らせする通知が届きます
              </p>
              <div class="Form__input_box--mt_sm">
                <div class="Radio__area">
                  <label class="Radio__box">
                    <input
                      v-model="$v.userInfo.is_received_information_notification.$model"
                      class="Radio__box_input"
                      type="radio"
                      name="radio3"
                      value="1"
                    >
                    <span class="Radio__box_input_dummy" />
                    <span class="Radio__box_tx">通知する</span>
                  </label>
                  <label class="Radio__box">
                    <input
                      v-model="$v.userInfo.is_received_information_notification.$model"
                      class="Radio__box_input"
                      type="radio"
                      name="radio3"
                      value="0"
                    >
                    <span class="Radio__box_input_dummy" />
                    <span class="Radio__box_tx">通知しない</span>
                  </label>
                </div>
              </div>
            </div>
            <button
              class="Btn__blue Form__btn Form__btn--sm_sp Form__btn--mt_md Form__btn--mt_lg Form__btn--mt_sp_lg"
              :disabled="$v.userInfo.$invalid"
              @click="updateUserInfo()"
            >
              変更する
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import authService from '@/services/authService'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { minValue } from 'vuelidate/lib/validators'
import { maxValue } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { redirect } from '@/helpers'
import checkNumber from '@/helpers/onlyNumber'
const validations = {
  userInfo: {
    time_before_received_class_start_notification: {
      required,
      maxValueValue: maxValue(1440),
      minValueValue: minValue(0)
    },
    is_received_favorite_class_notification: {},
    favorite_class_notification_received_time: {
      required: requiredIf(function() {
        return this.userInfo.is_received_favorite_class_notification === '1'
      })
    },
    is_received_log_input_notification: {},
    log_input_notification_received_time: {
      required: requiredIf(function() {
        return this.userInfo.is_received_log_input_notification === '1'
      })
    },
    is_received_information_notification: {}
  }
}
export default {
  name: 'ChangeNotification',
  mixins: [validationMixin],
  data() {
    return {
      userInfo: {
        time_before_received_class_start_notification: '',
        is_received_favorite_class_notification: '',
        favorite_class_notification_received_time: '',
        is_received_log_input_notification: '',
        log_input_notification_received_time: '',
        is_received_information_notification: ''
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    onlyNumber($event) {
      checkNumber.onlyNumber($event)
    },
    async init() {
      await this.getUserInfo()
    },
    async getUserInfo() {
      this.$store.dispatch('loading/updateLoading', true)
      const response = await authService.getUserInfo()
      const userInfoData = response.user.user
      this.userInfo.time_before_received_class_start_notification = userInfoData.time_before_received_class_start_notification
      this.userInfo.is_received_favorite_class_notification = userInfoData.is_received_favorite_class_notification
      this.userInfo.favorite_class_notification_received_time = userInfoData.favorite_class_notification_received_time
      this.userInfo.is_received_log_input_notification = userInfoData.is_received_log_input_notification
      this.userInfo.log_input_notification_received_time = userInfoData.log_input_notification_received_time
      this.userInfo.is_received_information_notification = userInfoData.is_received_information_notification
      this.$store.dispatch('loading/updateLoading', false)
    },
    async updateUserInfo() {
      this.$v.userInfo.$touch()
      if (this.$v.userInfo.$invalid) {
        return
      }
      const redirectPath = '/change/notification/thanks'
      await authService.updateUserInfo(this.userInfo)
      redirect(redirectPath)
    }
  },
  validations: validations
}
</script>
